<div class="content">
  <div class="container">

    <div class="row">
      <div class="col-12">
        <h2>Change password</h2>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="row form-group">
        <div class="col-md-4-5" style="position: relative">
          <label class="control-label" for="old-password">Old password <span class="color-red">*</span></label>
          <input type="{{inputOP}}" id="old-password" class="form-control input-view" formControlName="oldPassword">
          <em><mat-icon  class="icon" (click)="changeInputTypeOP()">remove_red_eye</mat-icon></em>
          <div *ngIf="form.get('oldPassword').invalid && form.get('oldPassword').touched" class="validation">
            <small *ngIf="form.get('oldPassword').errors['required']">Old password cant be empty</small>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-4-5" style="position: relative">
          <label class="control-label" for="password">New Password <span class="color-red">*</span></label>
          <input autocomplete="new-password" type="{{inputP}}" id="password" class="form-control input-view" formControlName="password">
          <em><mat-icon class="icon" (click)="changeInputTypeP()">remove_red_eye</mat-icon></em>
          <div *ngIf="form.get('password').invalid && form.get('password').touched" class="validation">
            <small *ngIf="form.get('password').errors['required']">Password cant be empty</small>
            <small *ngIf="form.get('password').errors['pattern']">The password is incorrect, please enter the password
              of minimum 8 characters that includes upper and lower case letters, digits and special symbols</small>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-4-5" style="position: relative">
          <label class="control-label" for="confirm-password">Repeat new password <span
            class="color-red">*</span></label>
          <input autocomplete="new-password" type="{{inputCP}}" id="confirm-password" class="form-control input-view" formControlName="confirmPassword">
          <em><mat-icon class="icon" (click)="changeInputTypeCP()">remove_red_eye</mat-icon></em>
          <div *ngIf="form.get('confirmPassword').invalid && form.get('confirmPassword').touched" class="validation">
            <small *ngIf="form.get('confirmPassword').errors['required']">Repeat new password cant be empty</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4-5">
          <div class="button">
            <button [disabled]="inProgress" class="btn custom-btn" type="submit"><span *ngIf="inProgress" class="spinner-border sr-only"></span>&nbsp;Change
              Password
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
